package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_area_data_di_AreaModule : Module get() = module {
	single() { _ -> com.essntl.features.area.data.repository.AreaRepositoryImpl(supabase=get()) } bind(com.essntl.features.area.domain.repository.AreaRepository::class)
	single() { _ -> com.essntl.features.area.data.supabase.AreaSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.area.data.supabase.AreaSupabaseDataSource::class)
}
public val com.essntl.features.area.data.di.AreaModule.module : org.koin.core.module.Module get() = com_essntl_features_area_data_di_AreaModule
